// response header on GET /exchange-rates/history: the number of days of the requested window that
// still have no rates because the upstream back-fill was capped. absent when the window is complete.
// the body stays a plain array, so a header carries the signal without a wrapper DTO
export const RATES_TRUNCATED_HEADER = 'X-Rates-Truncated'
